export default {
  name: '',
  code: '',
}
